import { useEffect, useState } from "react";
import { Form, Col, Row, Modal, Button, Spin } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import {
  CheckCircleOutlined,
  CloseOutlined,
  UnorderedListOutlined,
  DeleteOutlined,
  EditOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import {
  openConfirmNotification,
  openErrorNotification,
} from "../../../global/utils/toast";
import CommonBreadcrumb from "../../../global/components/CommonBreadcrumb";
import CommonButton from "../../../global/components/CommonButton";
import ConfirmModal from "../../../global/components/ConfirmModal";
import CustomInput from "../../../global/components/inputWidgets/CustomInput";
import PSIcon from "../../../assets/images/vectors/SideBarIcons/PSIcon";
import EngageModalForm from "./EngageModalForm";
import { getEnageUser } from "../../../global/hooks/getUserRole";
import usePostEngageLogin from "../../../global/hooks/usePostEngageLogin";
import { GlobalTable } from "../../../global/components/GlobalTable";
import { OperatorColumns } from "../Page/OperatorColumns";
import SentIcon from "../../../assets/images/vectors/SentIcon";
import OperatorInviteForm from "./OperatorInviteForm";

export const EngageForm = ({ type }) => {
  const [hoveredRow, setHoveredRow] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isEngageModalForm, setEngageModalForm] = useState(false);
  const [isOperatorInviteModal, setOperatorInviteModal] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [defaultValue, setDefaultValue] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showModalOperator, setShowModalOperator] = useState(false);
  const [form] = Form.useForm();
  const { id } = useParams();
  const navigate = useNavigate();
  const user = getEnageUser();

  // operations URLs
  const getUrl = `${process.env.REACT_APP_API_URL}/api/engage/get-sites-operators`;

  // engage site post URL
  const {
    data: operatorsData,
    loading: operatorsLoading,
    error: operatorsError,
    postData: getOperatorsAction,
  } = usePostEngageLogin(getUrl);

  // delete operator URL
  const deleteOperatorUrl = `${process.env.REACT_APP_API_URL}/api/engage/sites-operator-delete`;

  const {
    data: deleteOperatorData,
    loading: deleteOperatorLoading,
    error: deleteOperatorError,
    postData: deleteOperatorAction,
  } = usePostEngageLogin(deleteOperatorUrl);

  // enage site delete URL
  const deleteUrl = `${process.env.REACT_APP_API_URL}/api/engage/delete-site`;

  // engage site delete operation
  const {
    data: deleteData,
    loading: deleteLoading,
    error: deleteError,
    postData: deleteAction,
  } = usePostEngageLogin(deleteUrl);

  const engageSiteValue = JSON.parse(
    localStorage?.getItem("engageSiteData") || "{}"
  );

  const onFinish = async (values) => {};

  const onReset = () => {
    // form.resetFields();
    navigate(-1);
  };

  const onDeleteConfirm = async () => {
    try {
      if (id) {
        const body = {
          UserName: user?.username,
          PassWord: user?.password,
          SiteReference: [id],
        };
        await deleteAction(body);
      }
    } catch (error) {
      openErrorNotification("Something went wrong.");
    }
  };

  useEffect(() => {
    if (deleteData && deleteData?.status === 200) {
      openConfirmNotification("Success");
      navigate("/engagesitelist");
    } else if (deleteError) {
      openErrorNotification("Something went wrong.");
    }
  }, [deleteData]);

  const onDeleteConfirmOperator = async () => {
    try {
      if (selectedRowKeys.length > 0) {
        const body = {
          UserName: user?.username,
          PassWord: user?.password,
          OperatorId: selectedRowKeys,
        };
        await deleteOperatorAction(body);
        if (!deleteOperatorLoading) {
          setSelectedRowKeys([]);
        }
      }
    } catch (error) {
      openErrorNotification("Something went wrong.");
    }
  };

  useEffect(() => {
    if (deleteOperatorData && deleteOperatorData?.status === 200) {
      openConfirmNotification("Success");
      fetchOperatorData();
    } else if (deleteOperatorError) {
      openErrorNotification("Something went wrong.");
    }
  }, [deleteOperatorError, deleteOperatorData]);

  useEffect(() => {
    if (operatorsData?.data?.status === 403) {
      navigate("/engagesitelist");
    }
  }, [operatorsData]);

  const fetchOperatorData = () => {
    if (user?.username && user?.password && id) {
      const body = {
        UserName: user?.username,
        PassWord: user?.password,
        SiteReference: id ? id : "",
      };
      getOperatorsAction(body);
    }
  };

  useEffect(() => {
    fetchOperatorData();
  }, []);

  // console.log("operatorsData", operatorsData);

  useEffect(() => {
    if (!engageSiteValue) return;
    const getEngageData = () => {
      try {
        if (engageSiteValue) {
          form.setFieldsValue({
            SiteReference: engageSiteValue?.SiteReference,
            SiteName: engageSiteValue?.SiteName,
          });
          setDefaultValue({
            SiteReference: engageSiteValue?.SiteReference,
            SiteName: engageSiteValue?.SiteName,
          });
        } else {
          console.warn("No data found for the given ID");
        }
      } catch (error) {}
    };

    getEngageData();
  }, []);

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    fixed: true,
  };

  const breadcrumbItems = [
    {
      label: "Engage Site",
      href: "/engagesitelist",
    },
    {
      label: id ? (type === "info" ? "Information" : "Edit") : "Add",
      href: `/engagesite/info/${id}`,
    },
  ];

  const buttonsData =
    type === "info"
      ? [
          {
            label: "Edit",
            icon: <EditOutlined />,
            onClick: () => {
              setModalType("Edit");
              setEngageModalForm(true);
            },
          },
          deleteLoading
            ? {
                label: "",
                icon: (
                  <Spin
                    indicator={
                      <LoadingOutlined
                        spin
                        className="h-4 w-4"
                        style={{ color: "white" }}
                      />
                    }
                  />
                ),
              }
            : {
                label: "Delete",
                icon: <DeleteOutlined />,
                onClick: () => {
                  setShowModal(true);
                },
              },
          {
            label: "List",
            icon: <UnorderedListOutlined />,
            onClick: () => {
              navigate(-1);
            },
          },
        ]
      : [
          {
            label: "Apply",
            icon: <CheckCircleOutlined />,
            onClick: () => form.submit(),
          },
          {
            label: "Cancel",
            icon: <CloseOutlined />,
            onClick: onReset,
          },
        ];
  return (
    <>
      <Form
        validateTrigger={"onChange"}
        form={form}
        onFinish={onFinish}
        scrollToFirstError
        layout={"vertical"}
        autoComplete={"off"}
      >
        <div>
          <div className="pb-4 sticky -mt-4 pt-[6px] top-[55px] z-10 bg-[#f4f5f9]">
            <CommonBreadcrumb breadcrumbItems={breadcrumbItems}>
              <CommonButton buttonsData={buttonsData} />
            </CommonBreadcrumb>
          </div>

          {
            <div className="border bg-white rounded-[4px] overflow-hidden">
              <div className="flex items-center bg-gray-200 p-2.5">
                <PSIcon className="text-[18px] text-black " />
                <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                  Engage Site
                </span>
              </div>
              <div className="px-2 pt-1 pb-3">
                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Site Refrence"
                      name="SiteReference"
                      disabled={type === "info"}
                      required
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Name"
                      name="SiteName"
                      disabled={type === "info"}
                      required
                    />
                  </Col>
                </Row>
              </div>
            </div>
          }
        </div>
      </Form>
      <div className="mt-6">
        <div className="pb-4 flex items-center justify-end gap-2">
          <Button
            type="primary"
            icon={<SentIcon />}
            onClick={() => setOperatorInviteModal(true)}
            className="h-[30px] font-medium  min-w-[104px]"
          >
            Invite
          </Button>
          <Button
            type="primary"
            icon={deleteOperatorLoading ? null : <DeleteOutlined />}
            onClick={() => setShowModalOperator(true)}
            className="mr-2 h-[30px] font-medium min-w-[104px]"
            disabled={selectedRowKeys?.length === 0 ? true : false}
          >
            {deleteOperatorLoading ? (
              <Spin
                indicator={
                  <LoadingOutlined
                    spin
                    className="h-4 w-4"
                    style={{ color: "white" }}
                  />
                }
              />
            ) : (
              "Delete"
            )}
          </Button>
        </div>
        <GlobalTable
          columns={OperatorColumns()}
          dataSource={
            operatorsData?.data?.status !== 403 &&
            operatorsData?.data?.data?.length > 0
              ? operatorsData?.data?.data?.map((item, index) => ({
                  ...item,
                  key: item?.OperatorId,
                  id: index,
                }))
              : []
          }
          rowSelection={rowSelection}
          // pagination={paginationConfig}
          onRow={(record, rowIndex) => {
            return {
              onMouseEnter: () => setHoveredRow(rowIndex),
              onMouseLeave: () => setHoveredRow(null),
              // ...onRow?.(record, rowIndex),
            };
          }}
          loading={operatorsLoading}
        />
      </div>
      <Modal
        open={isEngageModalForm}
        onCancel={() => setEngageModalForm(false)}
        closeIcon={false}
        footer={null}
        width={580}
        centered
        motion={false}
        title={
          <div className="flex items-center bg-gray-200 p-2 rounded-md">
            <span className="text-[14px] font-[Poppins] text-black  ml-2">
              {modalType} Engage Site
            </span>
          </div>
        }
      >
        <EngageModalForm
          setEngageModalForm={setEngageModalForm}
          type={modalType}
          infoForm={form}
          defaultValue={defaultValue}
          setDefaultValue={setDefaultValue}
        />
      </Modal>
      <Modal
        open={isOperatorInviteModal}
        onCancel={() => setOperatorInviteModal(false)}
        closeIcon={false}
        footer={null}
        width={580}
        centered
        motion={false}
        title={
          <div className="flex items-center bg-gray-200 p-2 rounded-md">
            <span className="text-[14px] font-[Poppins] text-black  ml-2">
              Operator Invite
            </span>
          </div>
        }
      >
        <OperatorInviteForm
          setOperatorInviteModal={setOperatorInviteModal}
          siteRefrence={id}
        />
      </Modal>
      <ConfirmModal
        showModal={showModal}
        setShowModal={setShowModal}
        onDeleteConfirm={onDeleteConfirm}
      />
      <ConfirmModal
        showModal={showModalOperator}
        setShowModal={setShowModalOperator}
        onDeleteConfirm={onDeleteConfirmOperator}
      />
    </>
  );
};
